
export const getVideoRect = (containerRect, videoDimension, videoFit, crop = false) => {
    const aspectRatio = videoDimension.width / videoDimension.height;
    let videoRect;

    videoRect = { ...videoDimension };
    if (videoRect.height < containerRect.height) {
        videoRect.height = containerRect.height;
        videoRect.width = containerRect.height * aspectRatio;
    }
    if (videoRect.width < containerRect.width) {
        videoRect.width = containerRect.width;
        videoRect.height = containerRect.width / aspectRatio;
    }

    return videoRect;
};

export default getVideoRect;
